import { Component, OnInit, inject, input, viewChild } from '@angular/core';
import { Cmg1003AssetsQuery, Cmg1003AssetsStore, Cmg1003StoreQueryService } from '../../../loan-state';
import { bankingLiabilityAccountTypes, expenseTypes, liabilityTypes } from '../../../cmg-1003/models/lookups/assets.lookups';
import { BorrowerModel, LiabilityModel } from '../../../cmg-1003/models';
import { Table, TableModule } from 'primeng/table';
import { IdValue } from '../../models';
import { ConfirmationModalComponent } from '../../../core';
import { ConfirmationModalCloseType } from '../../../models';
import { DialogService } from 'primeng/dynamicdialog';
import { Panel } from 'primeng/panel';
import { PrimeTemplate } from 'primeng/api';
import { NgClass, AsyncPipe, DecimalPipe, CurrencyPipe } from '@angular/common';
import { Select } from 'primeng/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { SelectButton } from 'primeng/selectbutton';
import { InputNumber } from 'primeng/inputnumber';
import { CmgPrimeNgInputNumberFocusDirective } from '../../directives/cmg-input-number-focus.directive';
import { ButtonDirective, Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { LiabilityDetailsComponent } from './liability-details/liability-details.component';
import { NegativeCurrencyToParenthesisPipe } from '../../pipes/negative-currency-to-parenthesis.pipe';
import { ToBorrowerNamePipe } from '../../pipes/to-borrower-name.pipe';
import { ToNameOrValuePipe } from '../../pipes/to-name.pipe';
@Component({
  selector: 'cmg-clear2-ui-liabilities',
  templateUrl: './liabilities.component.html',
  styleUrls: ['./liabilities.component.scss'],
  imports: [
    Panel,
    PrimeTemplate,
    TableModule,
    NgClass,
    Select,
    ReactiveFormsModule,
    FormsModule,
    InputText,
    SelectButton,
    InputNumber,
    CmgPrimeNgInputNumberFocusDirective,
    ButtonDirective,
    Button,
    Dialog,
    LiabilityDetailsComponent,
    AsyncPipe,
    DecimalPipe,
    CurrencyPipe,
    NegativeCurrencyToParenthesisPipe,
    ToBorrowerNamePipe,
    ToNameOrValuePipe,
  ],
})
export class LiabilitiesComponent implements OnInit {
  private readonly _assetsQuery = inject(Cmg1003AssetsQuery);
  private readonly _assetStore = inject(Cmg1003AssetsStore);
  private readonly _storeQuery = inject(Cmg1003StoreQueryService);
  private readonly _dialogService = inject(DialogService);

  readonly table = viewChild<Table>('dt');

  readonly Borrower = input<BorrowerModel[]>(undefined);
  selectedLiability: LiabilityModel;
  showOtherLiability = false;
  liabilitiesGridColumns: any[];
  liabiltyAccountTypes = bankingLiabilityAccountTypes;
  bankingLiabilityAccountTypes = bankingLiabilityAccountTypes;
  liabilityTypes = liabilityTypes;
  expenseTypes = expenseTypes;
  liabilitiesList$ = this._assetsQuery.selectActiveLiabilitiesList();
  totalMonthlyPayments$ = this._assetsQuery.getTotalMonthlyPayments$();
  editingId: any = null;
  editable = false;
  borrowerId: number;
  applicationId: any;
  lastValue: boolean;
  borrowers: any;
  borrowerOptions: any[];
  id: number;
  value: string;
  isOtherLiability = false;
  isNewIncome = false;

  isFullyDisabled$ = this._storeQuery.statusRequiresDisabling$();

  displayPosition: boolean;
  position: string;
  header = 'CMG Financial';
  monthlyAmount = 0;

  ngOnInit(): void {
    this.liabilitiesGridColumns = [
      { field: 'applicationId', header: '', width: '0%' },
      { field: 'liabilityId', header: '', width: '0%' },
      { field: 'borrowerId', header: 'Borrower', width: '12%' },
      { field: 'liabilityType', header: 'Liability Type', width: '12%' },
      { field: 'accountType', header: 'Account Type', width: '10%' },
      { field: 'companyName', header: 'Liablity Name', width: '12%' },
      { field: 'omitted', header: 'Omit Liability', width: '10%' },
      { field: 'toBePaidOff', header: 'Paid Off', width: '10%' },
      { field: 'unpaidBalance', header: 'Unpaid Balance', width: '12%' },
      { field: 'monthlyPayment', header: 'Monthly Payments', width: '12%' },
      { field: 'actionsCol', header: 'Additional Info', width: '10%' },
    ];
    const Borrower = this.Borrower();
    this.applicationId = Borrower && Borrower[0].applicationId;
  }

  onRowEditCancel(appId: number, rowData) {
    if (this.isNewIncome) {
      this._assetStore.deleteLiability(appId, rowData.liabilityId);
    } else {
      this.liabilitiesList$.subscribe((val) => (this.table().value = val));
    }
  }

  onChangeLiablityType(event, appId: number, rowData) {
    if (event.value === 2) {
      this.isOtherLiability = true;
      rowData.accountType = 9;
      this._assetStore.updateLiability(appId, rowData);
      this._assetStore.update;
    } else {
      this.isOtherLiability = false;
    }
  }

  delete(ri, appId: number, liabilityId: number) {
    const dialogRef = this._dialogService.open(ConfirmationModalComponent, {
      closable: true,
      width: '512px',
      draggable: true,
      keepInViewport: true,
      data: {
        message: 'Are you sure you want to delete this liability?',
        header: 'Confirm',
        icon: 'pi pi-trash',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
      },
    });

    dialogRef.onClose.subscribe((value: ConfirmationModalCloseType) => {
      if (value === ConfirmationModalCloseType.ClosedViaAcceptButton) {
        this._assetStore.deleteLiability(appId, liabilityId);
        this._assetStore.update;
      }
    });
  }

  onRowEditSave(appId: number, row: LiabilityModel) {
    const currentRow: LiabilityModel = {
      ...row,
      accountType: row.accountType,
      omitted: row.omitted,
      toBePaidOff: row.toBePaidOff,
      borrowerId: row.borrowerId,
      monthlyPayment: row.monthlyPayment,
      liabilityId: row.liabilityId,
      companyName: row.companyName,
      unpaidBalance: row.unpaidBalance,
      otherExpenseType: row.otherExpenseType,
    };

    this._assetStore.updateLiability(appId, currentRow);
    this._assetStore.update;
  }

  onNewClicked() {
    this.isOtherLiability = false;
    if (this.Borrower().length > 1) {
      this.borrowerOptions = [
        new IdValue(this.Borrower()[0].borrowerId, this.Borrower()[0].firstName + ' ' + this.Borrower()[0].lastName),
        new IdValue(this.Borrower()[1].borrowerId, this.Borrower()[1].firstName + ' ' + this.Borrower()[1].lastName),
      ];
    }

    const newLiability = this._assetsQuery.getLiabilityById(0, this.Borrower()[0].borrowerId);
    const addRow = {
      ...newLiability,
      applicationId: this.applicationId,
    };
    this._assetStore.updateLiability(this.applicationId, addRow);
    this._assetStore.update;
    this.table().initRowEdit(addRow);
    this.isNewIncome = true;
  }

  onRowEditInit(ri, row) {
    if (this.Borrower().length > 1) {
      this.borrowerOptions = [
        new IdValue(this.Borrower()[0].borrowerId, this.Borrower()[0].firstName + ' ' + this.Borrower()[0].lastName),
        new IdValue(this.Borrower()[1].borrowerId, this.Borrower()[1].firstName + ' ' + this.Borrower()[1].lastName),
      ];
    }
    this.editingId = row.liabilityId;
    this.editable = !this.editable;
    this.isOtherLiability = row.liabilityType === 2 ? true : false;
  }

  showPositionDialog(position: string, ri, row) {
    if (row.companyName) {
      this.header = row.companyName;
    } else {
      this.header = expenseTypes.find((f) => f.id === row.otherExpenseType).value;
    }
    this.monthlyAmount = Number.isFinite(row.monthlyPayment) ? row.monthlyPayment : null;
    this.position = position;
    this.displayPosition = true;
    this.selectedLiability = row;
  }
}
